import { createSlice } from "@reduxjs/toolkit"

import wsClient from "src/wsClient"
import { addCasesForThunks } from "src/store/utils"

import initialState from "./initialState"
import thunks from "./thunks"
import reducers from "./reducers"

export const lobbySlice = createSlice({
  name: "lobby",
  initialState: initialState,
  reducers: {
    ...reducers,
    reset: () => {
      // Unconditionally. `close` is what drops the socket *and* the reconnection behind it, and
      // it used to run only for a socket already open — so a LEAVE pressed while the socket was
      // still connecting, or between two reconnection attempts, left a wire the server would go
      // on talking down: the next `lobby_refreshed` put the room back in the store and the lobby
      // pin walked the player back into it.
      wsClient.close("lobby")
      return initialState
    },
  },
  extraReducers(builder) {
    addCasesForThunks(builder, thunks)
  },
})

// Export only the reducer actions to be ran outside of the context to thunks.
// In other words, using the dispatch(reducerName({...})).
// Remember, you can not await the dispatch of a reducer action.
export const {
  setRoundSeconds,
  setLobbies,
  addChatMessage,
  addUserToLobby,
  removeUserFromLobby,
  addUserToTeam,
  removeUserFromTeam,
  changeUserRace,
  changeUserUnitIcon,
  switchUserLocation,
  leaveLobby,
  arrivedHome,
  setUserReady,
  unsetUserReady,
} = lobbySlice.actions

// Reducer is used by the store to set the state of the user slice
export default lobbySlice.reducer

// Export selectors and thunks to be able to be used from components easily
// in terms of the imports.
export * from "./thunks"
export * from "./selectors"
